const headers = {
  name: "Chart of Accounts",
  pagination: {
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  },
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search",
      value: "",
    },
    {
      type: "add",
      path: "/app/accounting/chart-of-accounts/add",
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Chart of Accounts",
        path: "",
      },
      {
        name: "Add",
        path: "/app/accounting/chart-of-accounts/add",
      },
    ],
  },
};

export default headers;
